import { VARIABLE_TYPES } from '../utils'
import { escapeRegExp } from 'lodash'

// cameras tipusu mezo id-re matchol
export const CAMERAS_ID_RE = /id_\d+(_\d+)*/g
// hibauzenetben szereplo elvaras-ertekre matchol (szam, date vagy datetime)
export const ERROR_VALUE_RE = /(?:\s)(\d+\S*\d*\S*)/g
// nyito es zaro HTML TAG-et keres barmilyen tartalommal kozotte
export const HTML_RE = new RegExp(/<\w+>.+<\/\w+>/g)
// teljes html tag-re matchol attributumokkal egyutt
export const HTML_TAG_RE = new RegExp(/<[^>]+>/g)
// e-mail
export const EMAIL_RE = new RegExp(
  /^((\w[^\W]+)[.-]?)+@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g,
)
// {{ $i18n.t('<String>') }} alaku nyelvesitesekre matchol, szimpla/dupla idezojellel, 0 vagy barmennyi space-szel a bajuszon belul
export const TEMPLATE_LOCALIZATION_RE = new RegExp(/{{\s*\$i18n.t\(['"](.+?)['"]\)\s*}}/g)
// fajlnevben kiterjesztesre matchol
export const FILE_EXTENSION_RE = new RegExp(/\.(\w+)$/g)
// file eleresben az utolso elemre matchol (fajlra, vagy mappara)
export const FILEPATH_TARGET_RE = new RegExp(/\/[\w. _-]+\/?$/g)
// filenev check kiterjesztessel
export const FILENAME_WITH_EXT_RE = new RegExp(/^[a-z0-9_.@() [\]-]+\.[a-z0-9]+$/gi)
// filenev check kiterjesztes nelkul
export const FILENAME_WITHOUT_EXT_RE = new RegExp(/^[a-z0-9_.@() [\]-]+$/gi)
// language-code
export const LANGUAGE_CODE_RE = new RegExp(/^[a-z]{2}-[a-z]{2}(-[a-z]{2})?$/i)

export const convertStringToRegExpSearchString = function (string) {
  if (typeof string !== VARIABLE_TYPES.STRING) return ''
  return escapeRegExp(string)
    .trim()
    .replace(/\s+/gm, '.*') // @regex lecserel minden szokozcsoportot '.*'-ra es
    .replaceAll('/', '\/') // forward slash-t kulon escapelni kell
}